import { graphql, StaticQuery } from "gatsby";
import React from "react";

import "typeface-roboto";

import { GetCookie } from "../../utils/utils";

import "../../assets/styles/layout.css";
import { Footer } from "./Footer";
import { Header } from "./Header";
import { Transition } from "./Transition";
import { EmergencyBanner } from "../EmergencyBanner";
import CookieWallComponent from "./CookieWallComponent";
import { connect } from "react-redux";
import { mapDispatchToProps, mapStateToProps } from "../../store";

class Layout extends React.Component {
  componentDidMount() {
    if (typeof window !== "undefined") {
      let queryParams = new URLSearchParams(window.location.search);
      let gclid = queryParams.get("gclid");
      let fbclid = queryParams.get("fbclid");

      if (gclid !== null) {
        document.cookie = "gclid=" + gclid + "; path=/";
      }

      if (fbclid !== null) {
        document.cookie = "fbclid=" + fbclid + "; path=/";
      }
    }
  }

  render() {
    let pathName = this.props.location.pathname;
    let { children } = this.props;

    let gclId = "";
    if (typeof window !== "undefined") {
      gclId = GetCookie("_gcl_au");
    }

    let tagManagerArgs = {
      gtmId: "GTM-MVJPDFR",
      dataLayer: {
        gclId: gclId ? gclId : "",
        jobTitle: this.props.jobTitle,
        jobTeam: this.props.jobTeam,
        jobSlug: this.props.jobSlug,
        jobId: this.props.jobId
      }
    };

    if (typeof window !== "undefined") {
      const TagManager = require("react-gtm-module");
      TagManager.initialize(tagManagerArgs);

      // eslint-disable-next-line global-require
      require("smooth-scroll")('a[href*="#"]', {
        offset: 145
      });
    }

    return (
      <StaticQuery
        query={graphql`
          query {
            site {
              siteMetadata {
                siteUrl
                title
                description
              }
            }
            allGreenhouseJob(filter: { board_type: { eq: "job" } }) {
              edges {
                node {
                  id
                }
              }
            }
            allPrismicSharedContent {
              nodes {
                data {
                  linkedin_link {
                    url
                  }
                  instagram_link {
                    url
                  }
                  facebook_link {
                    url
                  }
                  twitter_link {
                    url
                  }
                }
              }
            }
          }
        `}
        render={data => (
          <div>
            <CookieWallComponent location={this.props.location} />

            <EmergencyBanner />

            <Header
              data={data}
              pathname={pathName}
              jobNum={data.allGreenhouseJob.edges.length}
            />

            <div className={"page-content"}>
              <Transition location={this.props.location}>{children}</Transition>
            </div>

            <Footer data={data.allPrismicSharedContent.nodes[0].data} />
          </div>
        )}
      />
    );
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Layout);
